import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-303ae62f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lds-ring" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
		height_: {
			type: String,
			default: "40px",
		},
		width_: {
			type: String,
			default: "40px",
		},
		height: {
			type: String,
			default: "34px",
		},
		width: {
			type: String,
			default: "34px",
		},
		color: {
			type: String,
			default: "rgb(255, 255, 255)",
		},
	},
  setup(__props) {

_useCssVars(_ctx => ({
  "5da26b9f": (__props.width_),
  "369abc92": (__props.height_),
  "0a79a680": (__props.width),
  "43d3716d": (__props.height),
  "0ca7a346": (__props.color)
}))

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
}
}

})